var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,17.5v4a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0h13a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-1,0V1H1V21H13V17.5a.5.5,0,0,1,1,0Zm10-6.19a.36.36,0,0,0-.11-.16l-5-5a.49.49,0,0,0-.7.7L22.29,11H5.5a.5.5,0,0,0,0,1H22.29l-4.14,4.15a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0l5-5a.36.36,0,0,0,.11-.16A.5.5,0,0,0,24,11.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.18843db1271d56c6b294a718b0273cbd.svg";
export { ForwardRef as ReactComponent };